import type { SidePanel } from '../types';

export const ApiKeys: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./KeysPanel.vue')),
};
